const PublishUnpublishSchedules = (function () {
  function sortEmployeeString(a, b) {
    const [aLast, aFirst] = a.text.split(',').map(s => s.trim());
    const [bLast, bFirst] = b.text.split(',').map(s => s.trim());

    const lastCmp = aLast.localeCompare(bLast, undefined, { sensitivity: 'base' });
    if (lastCmp !== 0) return lastCmp;

    return aFirst.localeCompare(bFirst, undefined, { sensitivity: 'base' });
  }

  function populateLocationPubUnpubDropdown(dropdownEle, locations) {
    const dropdownData = locations
      .map(d => ({
        value: d.locationId,
        text: d.locationName,
      }))
      .filter(l => !l.id);

    dropdownData.unshift({
      value: '%',
      text: 'All',
    });
    dropdownData.unshift({
      value: '',
      text: '',
    });

    dropdown.populate(dropdownEle, dropdownData, '');
  }
  function populateEmployeePubUnpubDropdown(dropdownEle, employees) {
    let dropdownData = [];

    if ($.session.schedulingSecurity) {
      employees.forEach(d =>
        dropdownData.push({
          value: d.Person_Id,
          text: d.EmployeeName,
        }),
      );

      dropdownData.sort(sortEmployeeString);
    } else {
      dropdownData.unshift({
        value: $.session.PeopleId,
        text: `${$.session.LName}, ${$.session.Name}`,
      });
    }

    dropdownData.unshift({
      value: '%',
      text: 'All',
    });
    dropdownData.unshift({
      id: '',
      value: 'none',
      text: '(none)',
    });
    dropdownData.unshift({
      value: '',
      text: '',
    });

    dropdown.populate(dropdownEle, dropdownData, '');
  }

  function showPopup(employees, locations, callback) {
    const data = {
      locationId: '',
      employeeId: '',
      fromDate: '',
      toDate: '',
      notifyEmployee: '',
    };

    const pubUnpubPopup = POPUP.build({
      id: 'pubUnpubPopup',
      header: 'Publish Schedules',
    });

    const locationDropdown = dropdown.build({
      dropdownId: 'locationDropdown',
      label: 'Location',
      style: 'secondary',
    });
    const employeeDropdown = dropdown.build({
      dropdownId: 'employeeDropdown',
      label: 'Employee',
      style: 'secondary',
    });
    const fromDateInput = input.build({
      id: 'fromDateInput',
      type: 'date',
      label: 'From Date',
      style: 'secondary',
    });
    const toDateInput = input.build({
      id: 'toDateInput',
      type: 'date',
      label: 'To Date',
      style: 'secondary',
    });
    const notifyEmployees = input.buildCheckbox({
      text: 'Notify Employees',
      id: 'notifyEmployee',
      isChecked: false,
    });

    locationDropdown.classList.add('error');
    employeeDropdown.classList.add('error');
    fromDateInput.classList.add('error');
    toDateInput.classList.add('error');

    const dateWrap = document.createElement('div');
    dateWrap.classList.add('dateWrap');
    dateWrap.appendChild(fromDateInput);
    dateWrap.appendChild(toDateInput);

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('btnWrap');
    const publishBtn = button.build({
      text: 'Publish',
      style: 'secondary',
      type: 'contained',
      callback: async () => {
        POPUP.hide(pubUnpubPopup);
        callback(data, 'T');
      },
    });
    const unpublishBtn = button.build({
      text: 'Un-publish',
      style: 'secondary',
      type: 'contained',
      callback: async () => {
        POPUP.hide(pubUnpubPopup);
        callback(data, 'F');
      },
    });
    const cancelBtn = button.build({
      text: 'Cancel',
      style: 'secondary',
      type: 'outlined',
      callback: () => {
        POPUP.hide(pubUnpubPopup);
      },
    });
    buttonWrap.appendChild(publishBtn);
    buttonWrap.appendChild(unpublishBtn);
    buttonWrap.appendChild(cancelBtn);

    pubUnpubPopup.appendChild(locationDropdown);
    pubUnpubPopup.appendChild(employeeDropdown);
    pubUnpubPopup.appendChild(dateWrap);
    pubUnpubPopup.appendChild(notifyEmployees);
    pubUnpubPopup.appendChild(buttonWrap);

    populateLocationPubUnpubDropdown(locationDropdown, locations);
    populateEmployeePubUnpubDropdown(employeeDropdown, employees);

    publishBtn.classList.add('disabled');
    unpublishBtn.classList.add('disabled');

    // Event Listener
    function checkPubUnpubRequiredFields() {
      const hasErrors = [].slice.call(pubUnpubPopup.querySelectorAll('.error'));
      if (hasErrors.length === 0) {
        publishBtn.classList.remove('disabled');
        unpublishBtn.classList.remove('disabled');
      } else {
        publishBtn.classList.add('disabled');
        unpublishBtn.classList.add('disabled');
      }
    }
    pubUnpubPopup.addEventListener('change', e => {
      if (e.target.id === 'locationDropdown') {
        const selectedOption = e.target.options[e.target.selectedIndex];
        data.locationId = selectedOption.value;

        if (data.locationId) {
          locationDropdown.classList.remove('error');
        } else {
          locationDropdown.classList.add('error');
        }
      }
      if (e.target.id === 'employeeDropdown') {
        const selectedOption = e.target.options[e.target.selectedIndex];
        data.employeeId = selectedOption.value;

        if (data.employeeId) {
          employeeDropdown.classList.remove('error');
        } else {
          employeeDropdown.classList.add('error');
        }
      }
      if (e.target.id === 'fromDateInput') {
        data.fromDate = e.target.value;

        // 204977
        if (!data.fromDate || (data.toDate && data.fromDate > data.toDate)) {
          fromDateInput.classList.add('error');
        } else {
          fromDateInput.classList.remove('error');
        }
      }
      if (e.target.id === 'toDateInput') {
        data.toDate = e.target.value;

        // 204977
        if (!data.toDate || (data.fromDate && data.fromDate > data.toDate)) {
          toDateInput.classList.add('error');
        } else {
          toDateInput.classList.remove('error');
        }
      }
      if (e.target.id === 'notifyEmployee') {
        data.notifyEmployee = e.target.checked ? 'T' : 'F';
      }

      checkPubUnpubRequiredFields();
    });

    POPUP.show(pubUnpubPopup);
  }

  return {
    showPopup,
  };
})();
